import React from "react";
import { useRouteContext } from "@providers/RouteProvider";
import Header from "@components/Header";
import Footer from "@components/Footer";
import Banner from "@components/Banner";
import Breadcrumb from "@components/Breadcrumbs";

import Information from "@components/Offers/Information";
import SectionTabs from "@components/Offers/SectionTabs";
import StayInpired from "@components/Home/StayInspired";
import styles from "./Offers.module.scss";

import { usePageContext } from "@providers/PageProvider";
import helper from "@utils/helper";
import _ from "lodash";

const View = () => {
  const { router } = useRouteContext();
  const { pageData, hotel } = usePageContext();
  const banner = helper.formatBanner(pageData);
  const footer = helper.renderDetailsFooter(hotel);
  return (
    <div className="offersPage" data-scroll-container>
      <Header />
      <Banner
        // src="/offers/banner.jpg"
        titleProps={{ className: styles.title }}
        descProps={{ className: styles.description }}
        title={_.get(banner, "title", "")}
        description={_.get(banner, "description", "")}
        image={_.get(banner, "image")}
      />
      <Breadcrumb data={router.breadcrumbs("offers", { hotel })} mode="dark" />
      <Information />
      <SectionTabs />
      <StayInpired />
      {/* <Tabs defaultActiveKey={"all_offers"} items={TABS} /> */}
      <Footer
        data={{
          name: footer.name,
          address: footer.address,
          email: footer.email,
          phone: footer.phone,
        }}
      />
    </div>
  );
};

export default View;
